import iconImg from "../assets/facio-icon.png";
import wordmarkImg from "../assets/facio-wordmark.png";
import logoImg from "../assets/facio-logo.png";

// Icon-only "F" mark — fits tight headers, footers and buttons.
export function BrandMark({ className = "h-9 w-9" }) {
  return <img src={iconImg} alt="Facio Doc" className={`object-contain ${className}`} />;
}

// Icon + "Facio Doc" wordmark for the navbar / headers.
export function BrandLockup({ showTagline = false }) {
  return (
    <div className="flex items-center gap-2">
      <BrandMark />
      <div className="leading-none">
        <span className="font-display font-bold text-xl tracking-tight block">Facio Doc</span>
        {showTagline && (
          <span className="text-[10px] uppercase tracking-widest text-slate-400 font-mono">PDF &amp; Document Tools</span>
        )}
      </div>
    </div>
  );
}

// The "FACIO" wordmark artwork (icon + brand type) for hero / auth panels.
export function BrandWordmark({ className = "" }) {
  return <img src={wordmarkImg} alt="Facio" className={className} />;
}

// The full stacked artwork (mark + wordmark + tagline + credit).
export function BrandArtwork({ className = "" }) {
  return <img src={logoImg} alt="Facio Doc — PDF & Document Tools" className={className} />;
}
